<script setup lang="ts"></script>

<template>
  <div class="flex justify-between border-t px-4 py-3 first:border-t-0">
    <slot />
  </div>
</template>
